import React from 'react';
import './hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero__container">
        <div className="hero__grid">
          
          {/* Text Content */}
          <div className="hero__content">
            <h1 className="hero__h1">Leading JEE, NEET & Olympiad Preparation Institute in Dwarka</h1>
            <div className="hero__title">S-CUBUS</div>

            <p className="hero__quote">
              जो छात्र समर्पित हैं,<br />
              जो अनुशासित हैं,<br />
              और जो दृढ़ संकल्पित हैं —<br />
              सफलता उनके लिए विकल्प नहीं,<br />
              निश्चित परिणाम होता है।
            </p>

            <p className="hero__tagline">
              Empowering students with the right guidance to crack JEE, NEET, and Olympiads. 
              Your journey to excellence starts here.
            </p>

            <div className="hero__features">
              <div className="hero__feature">
                <div className="hero__feature-icon">✓</div>
                <span className="hero__feature-text">Expert Faculty</span>
              </div>
              <div className="hero__feature">
                <div className="hero__feature-icon">✓</div>
                <span className="hero__feature-text">Proven Results</span>
              </div>
            </div>
          </div>

          {/* Image Section */}
          <div className="hero__visual">
            <div className="hero__image-wrapper">
              <a 
                href="https://sathii.scubus.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hero__image-link-overlay"
                aria-label="Visit Sathi - Your Learning Companion"
              >
                <img
                  src="/logo/Sathii-Logo-Final.jpg.jpeg"
                  alt="Sathi - Your Learning Companion"
                  className="hero__image"
                />
                <div className="hero__click-hint">Click to explore →</div>
              </a>
              <div className="hero__live-indicator">
                <div className="hero__notification-dot"></div>
                <span className="hero__live-text">LIVE</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
